module.exports = __webpack_public_path__ + "img/PRAI Search.50659600.webp";